<style lang="scss" scoped>
    .tooltip {
        position: absolute;
        padding: 8px;
        font-size: toRem(12px);
        background-color: $color-primary;
        pointer-events: none;
        color: $white;
        opacity: 0;
        transition: opacity $transition-short;

        &.active {
            opacity: 1;
        }
    }
</style>
<template>
    <div class="tooltip" :class="{active}" :style="{top: `${top}px`, left: `${left}px`}">{{ text }}</div>
</template>
<script>
export default {
    name: 'Tooltip',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            required: true,
        },
        top: {
            type: Number,
            required: true,
        },
        left: {
            type: Number,
            required: true,
        },
    },
}
</script>
